import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { LocalStorageService } from './local-storage/local-storage.service';
import { StorageAdapter } from '../../domain/adapters/storage.adapter';
import { NotificationsAdapter } from '../../domain/adapters/notifications.adapter';
import { NotificationsService } from './notifications/notifications.service';
import { PageMetaTagsAdapter } from '../../domain/adapters/page-meta-tags.adapter';
import { PageMetaTagsService } from './page-meta-tags/page-meta-tags.service';

export function provideServices(): EnvironmentProviders {
  // Add only globally provided services here!
  return makeEnvironmentProviders([
    { provide: StorageAdapter, useClass: LocalStorageService },
    { provide: NotificationsAdapter, useClass: NotificationsService },
    {
      provide: PageMetaTagsAdapter,
      useClass: PageMetaTagsService,
    },
  ]);
}
